import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=e4f0afe6"
import script from "./product-list.vue?vue&type=script&lang=js"
export * from "./product-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports